/* eslint-disable max-len */
const STRINGS = {
	smapplyLogoAltText: gettext("SurveyMonkey Apply logo"),
	dontHaveAccount: gettext("Don't have an account?"),
	register: gettext("Register"),
	login: gettext("Log in"),
	emailAddress: gettext("Email address"),
	password: gettext("Password"),
	passwordLabel: gettext("Enter password"),
	enterPassword: gettext("Enter your password"),
	forgotPassword: gettext("Forgot password?"),
	forgotPasswordMessage: gettext(
		"Please check your email inbox. If you have an account, you'll receive an email with instructions on how to reset your password."
	),
	next: gettext("Next"),
	orLoginWith: gettext("Or log in with"),
	or: gettext("or"),
	back: gettext("Back"),
	help: gettext("Help"),
	termsOfUse: gettext("Terms of Use"),
	privacyNotice: gettext("Privacy Notice"),
	enterCode: gettext("Enter code to finish logging in"),
	checkAuthApp: gettext("Check your authenticator app for the code"),
	enterCodeProvided: gettext("Enter the code provided"),
	rememberDevice: gettext("Remember this device for 14 days"),
	submit: gettext("Submit"),
	tryAnotherMethod: gettext("Try another method"),
	couldNotVerifyCode: gettext("We couldn't verify the code. Please try again later."),
	mfaCodeExpired: gettext("Code expired. Refresh the page and try again."),
	too_many_attempts: gettext("Too many login attempts. Wait a few minutes, then try again."),
	invalid_credentials: gettext("Invalid email or password."),
	account_locked: gettext(
		"Invalid email or password. Your account has been temporarily locked due to too many failed login attempts. Please try again later."
	),
	site_inactive: gettext(
		"Only site administrators can log in at this time. Please contact the sites administrator for assistance."
	),
	user_inactive: gettext(
		"Your account is inactive. Please contact technical support for assistance."
	),
	site_user_inactive: gettext(
		"Your account is inactive. Please contact the site administrator for assistance."
	),
	site_user_doesnt_exist: gettext(
		"Your account is not associated with this site. Registration is required before logging in."
	),
	unknownError: gettext(
		"An unknown error has occurred. Please contact technical support for assistance."
	),
	cookie_not_enabled: gettext(
		"Cookies are not enabled in your browser. Please enable cookies to continue."
	),
	invalid_email: gettext("Please enter a valid email address."),
	success: gettext("Success!"),
	rateLimitError: gettext(
		"You can't send another request right now. Please wait a few minutes and try again."
	),
	requestSent: gettext("Request sent!"),
	staff_login_restricted: gettext("Login failed, staff login is restricted to marketplace."),
	error: gettext("Error"),
	important: gettext("Important"),
	saveBtn: gettext("Save"),
	cancel: gettext("Cancel"),
	cancelBtn: gettext("Cancel"),
	ok: gettext("Ok"),
	credentialsTableHeader: gettext("Credentials"),
	name: gettext("Name"),
	currentPassword: gettext("Current Password"),
	newPassword: gettext("New Password"),
	email: gettext("Email"),
	preferredLanguage: gettext("Preferred Language"),
	language: gettext("Language"),
	languageNote: gettext(
		"Note: Only sites with this language enabled will use your preferred language."
	),
	timezone: gettext("Timezone"),
	disconnectBtn: gettext("Disconnect"),
	change: gettext("Change"),
	clear: gettext("Clear"),
	unsavedChanges: gettext("Unsaved Changes"),
	firstName: gettext("First Name"),
	lastName: gettext("Last Name"),
	googleSSO: gettext("Google Social Sign On"),
	pleaseSelect: gettext("Please Select..."),
	resendRequest: gettext("Resend Request"),
	emailAddressChangePending: gettext("An email address change has been requested"),
	currentlyEditing: gettext("You must finish editing before you can save changes"),
	newPasswordPlaceholder: gettext("Create your password"),
	applicantNotificationsLabel: gettext("Applicant Notifications"),
	reviewerNotificationsLabel: gettext("Reviewer Notifications"),
	recommenderNotificationsLabel: gettext("Recommender Notifications"),
	generalNotifications: gettext("General"),
	recaptchaVerificationFailed: gettext("Recaptcha verification failed. Please try again."),
	optional: gettext("Optional"),
	instructions: gettext("Instructions"),
	deactivateMFATitle: gettext("Remove multi-factor authentication?"),
	deactivateMFAWarning: gettext(
		"Multi-factor authentication helps protect your account. If you’ve lost your device, we recommend changing your enrolled device from My Account instead of disabling MFA."
	),
	deactivateMFAWarningLink: gettext("change your enrolled device"),
	deactivateMFAWarning2: gettext(
		"(recommended) rather than disabling two-factor authentication."
	),
	deactivateMFAContinueTOTP: gettext(
		"To continue, check your authenticator app for the code, and enter it the field below."
	),
	deactivateMFAContinueEmail: gettext(
		"To continue, check the code sent to your email, and enter it in the field below."
	),
	deactivateMFA: gettext("Deactivate MFA"),
	invalid_action: gettext(
		"An invalid action was requested. Please contact technical support for assistance."
	),
	mfa_disabled: gettext("Multi-factor authentication has been removed from your account."),
	site_requires_mfa: gettext(
		"You are a member of a site that requires multi-factor authentication so you cannot remove it."
	),
	recoveryCodes: gettext("Recovery Codes"),
	recoveryCodesDescription: gettext(
		"Backup codes are one-time use codes that can be used to log in to your account if you lose access to your multi-factor authentication device."
	),
	whenYouLogin: gettext(
		"When you log in, you’ll be asked to retrieve a code from the authenticator app on your new mobile device."
	),
	learnMoreAboutManagingMFA: gettext("Learn more about managing MFA."),
	done: gettext("Done"),
	invalid_code: gettext("Invalid code. Please try again."),
	generateRecoveryCodes: gettext("Generate Recovery Codes"),
	generateNewCodesWarning: gettext(
		"Generating new recovery codes will invalidate any remaining old codes."
	),
	getNewCodes: gettext("Get New Codes"),
	changeMFADevice: gettext("Change MFA Device"),
	changeMFADeviceMessage: gettext(
		"Before continuing, make sure you have your old device and the new device with an authenticator app installed.\nLost old device? Recover your account on the next screen."
	),
	changeDevice: gettext("Change Device"),
	changeRecoveryEmail: gettext("Change Recovery Email"),
	addRecoveryEmail: gettext("Add Recovery Email"),
	recoveryEmail: gettext("Recovery Email"),
	addRecoveryEmailPlaceholder: gettext("Enter recovery email address"),
	currentRecoveryEmail: gettext("Current recovery email"),
	code_sent: gettext("We've sent a code to your email address"),
	sendCode: gettext("Send Code"),
	errorHasOccurred: gettext("An error has occurred. Please try again later."),
	code_already_pending: gettext(
		"A code has already been sent to your email address. Please check your email and enter the code below."
	),
	fieldErrors: {
		email: gettext("Please enter a valid email address"),
		text: gettext("Field is required"),
		currentPassword: gettext("Please enter your current password"),
		newPassword: gettext(
			"Passwords must be at least 8 characters long, contain at least one number and special character, and have both upper and lower case letters"
		),
		invalidFirstName: gettext("Invalid first name"),
		invalidLastName: gettext("Invalid last name"),
		invalidEmail: gettext("Invalid email"),
		invalidPassword: gettext("A stronger password is required"),
		invalidOrganizationName: gettext("Organization name is required"),
		invalidCaptcha: gettext("Invalid captcha, please try again"),
		invalidTaxNumber: gettext("Tax number is required"),
	},
	becomingApplicantMessage: gettext(
		"To finish setting up your applicant account, complete any required fields below and click Save."
	),
	navigateAwayWarning: gettext(
		"If you navigate away from this page without clicking save, your changes will be lost."
	),
	loginPage: { loginWithGoogle: gettext("Login with Google") },
	registrationPage: {
		returnTo: gettext("Return to"),
		registrationPageTitle: gettext("Register for an applicant account"),
		alreadyHaveAccount: gettext("Already have a SurveyMonkey Apply account?"),
		individualTabTitle: gettext("Register as an individual"),
		organizationTabTitle: gettext("Register as an organization"),
		firstName: gettext("First Name"),
		lastName: gettext("Last Name"),
		email: gettext("Email"),
		termsAndPolicy: gettext("By registering for an account, you agree to our"),
		termsOfService: gettext("terms of service"),
		privacyPolicy: gettext("privacy policy"),
		and: gettext("and"),
		createAccount: gettext("Create Account"),
		registerWithGoogle: gettext("Register with Google"),
		orgName: gettext("Organization name"),
		taxNumber: gettext("Tax number"),
		invalidCaptcha: gettext("Invalid captcha code"),
		password: gettext("Create a password"),
	},
	labels: { mfaSwitch: gettext("Multi-Factor Authentication Toggle") },
	accountSettingsPage: {
		title: gettext("My Account"),
		modals: {
			disconnectAccountModal: {
				areYouSureTitle: gettext("Are you sure?"),
				upperText: gettext(
					"Disconnecting your Google account from your SurveyMonkey Apply account means you will no longer use Google to sign into Apply. This cannot be undone."
				),
				lowerText: gettext(
					"To continue, please provide a password in the field below and click Disconnect."
				),
			},
			BecomeApplicantModal: {
				title: gettext("Become An Applicant"),
				bodyCfsRequired: gettext(
					"Some fields are required to complete your request. Please complete the fields below to continue."
				),
				requiredFields: gettext("Required Fields"),
			},
			changeRecoveryEmailModal: {
				step1Title: gettext("Verify your current recovery email"),
				step1Description: gettext(
					"To change your recovery email, first verify your current one"
				),
				step2Title: gettext("Enter your new recovery email"),
				step2Description: gettext(
					"Enter the new email address you want to use for account recovery"
				),
				step3Title: gettext("Verify your new recovery email"),
				step3Description: gettext("Enter the verification code sent to"),
				cancelConfirmation: gettext(
					"Are you sure you want to cancel? Your progress will be lost."
				),
			},
		},
		myProfileTab: {
			title: gettext("My Profile"),
			profileImage: gettext("Profile Image"),
			personalInfo: gettext("Personal Info"),
			managedBySSO: gettext("Managed by Single Sign On"),
			ssoNameTooltip: gettext(
				"Your first and last name are managed by Single sign-on and cannot be changed here. Please contact the sites administrator to request a change."
			),
			ssoEmailTooltip: gettext(
				"Your email address is managed by Single sign-on and cannot be changed here. Please contact the sites administrator to request a change."
			),
			ssoPasswordTooltip: gettext("Your password will not be bla bla."),
			ssoOnlyPasswordTooltip: gettext("Your password SSO ONLY."),
			linkedAccounts: gettext("Linked Accounts"),
			socialSignOn: gettext("Social Sign-on"),
			disconnectAccount: gettext("Disconnect account"),
			generalPreferences: gettext("General Preferences"),
			mfaEnabled: gettext("Multi-factor authentication (MFA)"),
			mfaLearnMoreLink: gettext("Learn more"),
			mfaLearnMoreText: gettext(
				"Get added security by confirming your identity via mobile device at login."
			),
			changeEnrolledDevice: gettext("Change enrolled device"),
			generateNewCodes: gettext("Generate new recovery codes"),
			emailChangeRequested: gettext(
				"You have requested to change your account email address to"
			),
			emailChangeCheckEmail: gettext(
				"Please check your new email address for a confirmation email to complete the change."
			),
			enrolledMethod: gettext("Enrolled Method"),
			totp: gettext("Authenticator App"),
			email: gettext("Email"),
		},
		userSectionTab: {
			title: gettext("Site Settings"),
			registration: gettext("Registration"),
			notApplicantTitle: gettext("You are not registered on this site as an applicant."),
			becomeApplicant: gettext("Become an applicant"),
			setupOrganizationTitle: gettext("Set up an organization to apply on behalf of."),
			setupOrganization: gettext("Set up organization"),
			customFieldsLabel: gettext("Extras"),
			organizations: gettext("Your Organizations"),
			organizationName: gettext("Organization Name"),
			organizationRole: gettext("Role"),
			primary_admin: gettext("Primary Organization Manager"),
			admin: gettext("Manager"),
			member: gettext("Member"),
			registrationClosed: gettext("Registration is currently closed for this site."),
			registrationClosedMessage: gettext(
				"Registration is currently closed for this site. Please check back later."
			),
		},
		notificationSettingsTab: {
			title: gettext("Notification Settings"),
			cardTitle: gettext("Notifications from this site"),
			notify_direct_messages: gettext("Direct messages from the site administrator"),
			request_review: gettext("Request to review applications"),
			notify_recommender_updates: gettext("Updates on my recommendations"),
			email_subscribed: gettext("Unsubscribe from all emails from this site"),
			notify_applicant_activity: gettext("Updates on activity regarding my applications"),
			notify_applicant_invitation: gettext(
				"Invitation requests to collaborate on an application"
			),
			notify_applicant_reminders: gettext("Deadline reminders for applications"),
			notify_reviewer_assigned: gettext("Emails when I've been assigned a review"),
			notify_reviewer_reminders: gettext("Deadline reminders for reviews"),
			notify_recommender_reminders: gettext("Deadline reminders for recommendations"),
			notify_recommender_requests: gettext(
				"Invitation requests to act as a recommender on an application"
			),
		},
		userEligibilityTab: {
			title: gettext("Eligibility"),
			eligibilityProfile: gettext("Eligibility Profile"),
			completeEligibilityProfileBtn: gettext("Complete eligibility profile"),
			fillOutEligibilityBtn: gettext("Fill out eligibility profile"),
			eligibilityNotStarted: gettext("Eligibility has not been started"),
		},
		needHelp: gettext("NEED HELP?"),
		CustomerSupportText: gettext("24/7 email customer support"),
		visitHelpCenter: gettext("Visit our Help Center"),
	},
	passwordField: {
		charactersLong: gettext("Password must contain at least 8 characters"),
		charactersUpper: gettext("Password must contain at least 1 uppercase character"),
		charactersSpecial: gettext("Password must contain at least 1 special character"),
		charactersNumbers: gettext("Password must contain at least 1 number"),
		passwordLabel: gettext("Password"),
		confirmPassword: gettext("Confirm password"),
	},
	toast: {
		success: gettext("Success"),
		error: gettext("Error"),
		accountDisconnected: gettext("Account disconnected"),
		customFieldErrors: gettext(
			"One or more errors occurred while saving custom fields, your account has not been updated"
		),
		accountUpdated: gettext("Account has been updated"),
		accountNotUpdated: gettext(
			"One or more errors occurred, your account has not been updated"
		),
		accountSettingsReset: gettext("Account settings have been reset"),
		emailChangeRequestResent: gettext("Request to change email address has been resent"),
		unknownError: gettext("An unknown error has occurred, please contact technical support"),
		invalidPassword: gettext("The password you have entered is invalid, please try again"),
		mfaRemoved: gettext("Multi-factor authentication has been removed from your account"),
		mfaEnrolled: gettext(
			"Multi-factor authentication has been successfully enrolled on your account"
		),
		mfaDeviceChanged: gettext(
			"Your multi-factor authentication device has been successfully changed"
		),
		languageNotSupported: gettext("This language is not supported by this site"),
		recoveryEmailUpdated: gettext("Recovery email has been successfully updated"),
	},
};

export default STRINGS;
